var text_field_default = {
  "root": "kPCun",
  "text": "PddDC",
  "input": "p9HCi",
  "small": "dlzzB",
  "medium": "Lk-1E",
  "large": "X2BH5",
  "webview": "K97ME",
  "endAdornment": "EmLzH",
  "shown": "_7k5KE",
  "value": "lH6tr",
  "spinner": "eeeOu",
  "spin": "_2RW2e"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
